(function () {
  // The section is a normal (non-limited) repeatable section — a merchant
  // can add it more than once to a page (e.g. header strip + footer
  // ticker). Each instance renders its own <script src> tag, and a browser
  // executes every <script> element it encounters regardless of whether
  // the same src already ran elsewhere, so a second instance would
  // register a second click listener without this guard — double-toggling
  // the class (net no-op) while aria-pressed still gets rewritten to a
  // stale value.
  if (window.__ehMarqueeInit) return;
  window.__ehMarqueeInit = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-eh-marquee-toggle]');
    if (!button) return;

    var marquee = button.closest('.eh-marquee');
    if (!marquee) return;

    var paused = marquee.classList.toggle('eh-marquee--paused');
    button.setAttribute('aria-pressed', String(paused));
  });
})();
